import * as React from "react";

import {Layout} from "src/components/organisms/Layout";
import {Promo} from "src/components/organisms/Promo";
import * as pageStyles from "src/styles/pages/webinars/webinar.module.scss";
import {StaticImage} from "gatsby-plugin-image";

import {graphql, type HeadFC} from "gatsby";
import type {GatsbyTypes} from "gatsby-types";
import {BackgroundImage} from "src/components/organisms/BackgroundImage";
import * as styles from "components/organisms/Layout/styles.module.scss";
import {SubscribeForm} from "components/organisms/ContactsForm/blocks/SubscribeForm";
import {Advantages} from "components/organisms/Advantages";
import circleIcon from "src/images/pages/webinars/mastering-kubernetes-best-practices/circle.svg";
import arrowsIcon from "src/images/pages/webinars/mastering-kubernetes-best-practices/arrow.svg";
import stackIcon from "src/images/pages/webinars/mastering-kubernetes-best-practices/stack.svg";
import {Props as CardProps} from "components/organisms/ProductCard";
import cls from "classnames";
import {useState} from "react";

type Item = CardProps & { id: number }

export const cards3: Item[] = [
    {
        id: 1,
        icon: arrowsIcon,
        title: "快速部署 Dockerfile：",
        headingLevel: 4,
        description: '了解如何构建 Dockerfile，显著缩短部署时间、最大限度减少网络流量并节省磁盘空间，从而更快、更高效地完成部署。',
        className: cls(styles.card, pageStyles.advantagesWrapper),
        childrenClassNames: {
            title: 'color-white',
            description: 'color-gray'
        },
    },
    {
        id: 2,
        icon: stackIcon,
        title: "通过 Buildpacks 更上一层楼：",
        headingLevel: 4,
        description: '学习如何使用 Buildpacks 简化部署流程，无需手动写入 Dockerfile，同时确保 Spring Boot 应用程序的优化构建。',
        className: cls(styles.card, pageStyles.advantagesWrapper),
        childrenClassNames: {
            title: 'color-white',
            description: 'color-gray'
        },
    },
    {
        id: 3,
        icon: circleIcon,
        title: "在 Kubernetes 内实现 Spring Boot 的便捷管理：",
        headingLevel: 4,
        description: '掌握在 Kubernetes 中对 Spring Boot 服务进行无缝配置更改的技术，无需重新部署，从而确保服务的持续可用。',
        className: cls(styles.card, pageStyles.advantagesWrapper),
        childrenClassNames: {
            title: 'color-white',
            description: 'color-gray'
        },
    }
]

interface Props {
    data: GatsbyTypes.Query
}

const IndexPage: React.FC<Props> = ({data}) => {

    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    return (
        <Layout button={{
            className: 'bg-cyan color-dark'
        }}
                languages={[
                    {
                        language: "English",
                        href: "/webinars/mastering-kubernetes-best-practices/"
                    }
                ]}
                selectedLanguage={"Chinese"}
                forms={data.forms.nodes}
        >

            <Promo
                detail={<>
                    <span className={"color-gray p-3"}>
                    <i className={"bs-icon icon-broadcast xs p-3"}/> 在线网络研讨会</span>
                </>
                }
                className={cls("bg-black", pageStyles.promoWrapper)}
                style={{maxWidth: '720px'}}
                title={"掌握\n" +
                    "Kubernetes:"}
                subtitle={"部署 Spring Boot\n" +
                    "应用程序的最佳实操"}
                additionalContentNode={
                    <StaticImage
                        alt={""}
                        src={"../../../images/pages/webinars/mastering-kubernetes-best-practices/additional.png"}/>
                }
                childrenClassNames={
                    {
                        content: pageStyles.promoContent,
                    }
                }
                description={
                    <div>
                        <p className={"p-2 color-blue"}>
                            2024 年 8 月 28 日，星期三
                        </p>
                        <p className={"p-2 color-blue"}>
                            16:00 (GMT+8)
                        </p>
                        {!isSuccess ? <SubscribeForm
                            requiredMessage={"* 此字段必填"}
                            placeholder={"电子邮件"}
                            formId={"a7e4ca55-0f80-404a-8fe0-684adaf8ec48"}
                            classNames={{
                                container: styles.perfBannerContainer,
                                placeholder: styles.perfBannerPlaceholder,
                                terms: "color-gray",
                                input: {
                                    container: styles.perfBannerInputContainer,
                                    containerActive: styles.perfBannerInputContainerActive,
                                }
                            }}
                            button={
                                {
                                    caption: '立即注册',
                                    className: "button-filled bg-cyan color-black"
                                }
                            } onSubmit={() => {
                            setIsSuccess(true)
                        }}
                            terms={{
                                name: 'privacystatement',
                                caption: <span
                                    className={"p-3 color-white"}>我同意条款和<a
                                    className={"p-3 color-blue"}
                                    href="/privacy-policy/">隐私声明</a></span>
                            }}></SubscribeForm> : <p
                            style={{
                                marginTop: "25px"
                            }}
                            className={"p-1 color-white"}>
                            感谢您注册我们的在线研讨会
                        </p>}
                    </div>
                }
            />

            <Advantages
                className={pageStyles.advantagesContainer}
                bg={"black"}
                items={cards3}/>

            <BackgroundImage
                bgClassName={pageStyles.authorBg}
                className={"bg-black"} alt={""}
                objectPosition={"bottom center"}
                objectFit={"contain"} desktop={
                <StaticImage alt={""} objectFit={"contain"}
                             src={"../../../images/pages/webinars/mastering-kubernetes-best-practices/bg.png"}/>
            }>
                <Promo
                    style={{maxWidth: '620px'}}
                    title={"Dmitry Chuyko"}
                    subtitle={"BellSoft 性能架构师"}
                    detail={<span className={"p-2 color-gray"}>网络研讨会主讲人</span>}
                    childrenClassNames={
                        {
                            contentWrapper: pageStyles.authorContentWrapper,
                            additionalContent: pageStyles.author,
                            detail: pageStyles.authorDetail,
                            container: pageStyles.authorContainer
                        }
                    }
                    components={
                        {
                            title: "h2"
                        }
                    }
                    description={
                        <div>
                            <p className={"p-3 color-gray"}>
                                Dmitry 是 BellSoft 的性能架构师，也是公司 OpenJDK 社区的主要贡献者。Dmitry 擅长针对 x86 和
                                ARM 架构优化 OpenJDK，并在促进轻量级 Java 容器的开发方面发挥了关键作用。
                            </p>
                            <div className={pageStyles.social}>
                                <div className={pageStyles.socialItem}>
                                    <a href="https://www.linkedin.com/company/bell-sw" target="_blank"
                                       rel="noopener noreferrer"><i className="bs-icon icon-linkedin"/></a>
                                </div>
                                <div className={pageStyles.socialItem}>
                                    <a href="https://twitter.com/bellsoftware" target="_blank"
                                       rel="noopener noreferrer"><i
                                        className="bs-icon icon-twitter"/></a>
                                </div>
                            </div>
                            <div className={pageStyles.author}>
                                <StaticImage alt={""} objectFit={"contain"}
                                             src={"../../../images/pages/webinars/mastering-kubernetes-best-practices/dmitry.png"}/>
                            </div>
                        </div>
                    }
                />
            </BackgroundImage>
        </Layout>
    )
}

export default IndexPage

export const query = graphql`
  query {
    forms: allFormsJson(filter: {fields: {hashedIdSelector: {in: ["#popup-request-quote"]}}}) {
            nodes {
              fields {
                idSelector
                hashedIdSelector
              }
              formId
              details
              title
              successDescription
              successDetails
              successTitle
              items {
                name
                placeholder
                required
                hidden
                type
                gridColumn
              }
              controls {
                terms {
                  name
                }
                button {
                  caption
                }
              }
            }
          }
  }
`

export const Head: HeadFC = () =>
    <>
        <title>掌握 Kubernetes: 部署 Spring Boot 应用程序的最佳实操 | Java runtime from an OpenJDK contributor</title>
        <link rel="alternate"
              href={(`${process.env.GATSBY_CURRENT_BASE}/webinars/mastering-kubernetes-best-practices/`)}
              hrefLang="x-default"/>
        <link rel="alternate"
              href={(`${process.env.GATSBY_CURRENT_BASE}/webinars/mastering-kubernetes-best-practices/`)}
              hrefLang="en"/>
        <link rel="alternate"
              href={(`${process.env.GATSBY_CURRENT_BASE}/zh-cn/webinars/mastering-kubernetes-best-practices/`)}
              hrefLang="zh-hans"/>
    </>
